module.exports = __webpack_public_path__ + "img/JustNamew.5a73e4c7.svg";